import { render, staticRenderFns } from "./DashBoardEspecialista.vue?vue&type=template&id=00e4571e"
import script from "./DashBoardEspecialista.vue?vue&type=script&lang=js"
export * from "./DashBoardEspecialista.vue?vue&type=script&lang=js"
import style0 from "./DashBoardEspecialista.vue?vue&type=style&index=0&id=00e4571e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports